import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { updateVolume3DURL } from '../../settings/api';

import Modal from './ModalStyled';
import ButtonDefault from '../buttons/ButtonDefault';

import { apiFetch } from '../../utils/requests';
import { getToken } from '../../modules/auth/selectors';
import { updateVolume3DAction } from '../../modules/volume3Ds/updateVolume3D';
import { showNotificationError } from '../../modules/notifications/showNotification';

export default function ConfirmPatientInfoModal({ volID, volName, scanName, show, onClose }) {
  const token = useSelector(({ auth }) => getToken(auth));
  const dispatch = useDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateSeriesName = () => {
    const body = {
      PatientName: scanName,
    };

    setIsSubmitting(true);

    apiFetch(updateVolume3DURL(volID), token, 'PATCH', body)
      .then(volume3D => {
        setIsSubmitting(false);
        dispatch(updateVolume3DAction(volume3D));
        window.location.reload();
        onClose();
      })
      .catch(err => {
        setIsSubmitting(false);
        onClose();
        dispatch(showNotificationError('An unexpected error occurred while updating volume3D.'));
        // eslint-disable-next-line no-console
        console.error(err);
      });
  };

  return (
    <ConfirmNameModal show={show} centered backdropClassName='modal-backdrop-blur'>
      <ModalHeader>Confirm Scan And Series Refer To The Same Patient?</ModalHeader>
      <ModalBody>
        {`The selected series's patient name "${volName}" does not match the scan's patient name "${scanName}"`}
      </ModalBody>
      <Modal.Footer>
        <CancelBtn disabled={isSubmitting} onClick={onClose}>
          Cancel
        </CancelBtn>
        <UpdateBtn disabled={isSubmitting} onClick={updateSeriesName}>
          Update Series Name
        </UpdateBtn>
      </Modal.Footer>
    </ConfirmNameModal>
  );
}

ConfirmPatientInfoModal.propTypes = {
  volName: PropTypes.string.isRequired,
  volID: PropTypes.string.isRequired,
  scanName: PropTypes.string.isRequired,
};

const ConfirmNameModal = styled(Modal)`
  .modal-dialog {
    max-width: 600px;
  }
`;

const ModalHeader = styled(Modal.Header)`
  justify-content: flex-start;
`;

const ModalBody = styled(Modal.Body)`
  padding-top: 5px;
  padding-bottom: 0;
  font-size: 16px;
`;

const CancelBtn = styled(ButtonDefault)`
  width: 190px;
  background-color: #969696;
  margin-right: 20px !important;
`;

const UpdateBtn = styled(ButtonDefault)`
  width: 190px;
  background-color: #8f0000;
`;
